export const buildTarget = (selectors) => selectors.join(' ');
